import { Fic } from './fic';

export class ProFile  {
    passcode:string;
    files:Array<Fic> = new Array();
    constructor(){}
}